export const copyFunctionalityControlId: string =
	"259aeb5d-2c34-4e85-b9e2-51d5fe053745";
export const skipCopyPrefixId: string = "SkipCopy_";
export const updateExistingCardPrefixId: string = "Update_";
export const popupCloseId: string = "63c73e2b-03d3-4080-b84a-9568fff726da";
export const popupCancelId: string = "2a160d96-b63d-47c6-b463-5dc9c3fc542d";
export const popupCardPrefixId: string = "CardPopup_";
export const popupHTMLPrefixId: string = "HTMLPopup_";
export const popupSubmitId: string = "5fbb12bb-e172-4639-82f5-72edbd8a97c6";
export const botAvatarBackgroundColor: string = "transparent";
export const userAvatarBackgroundColor: string = "#0063B1";
export const feedbackLikeControlId: string =
	"623f9df7-7b61-4098-8fee-4455c59d6aee";
export const feedbackDislikeControlId: string =
	"148493dd-f9a6-4666-a5ac-e304ddab8927";
export const feedbackLikeTableControlId: string =
	"833b7a41-9e38-410f-917f-3a74e8c5c727";
export const feedbackDislikeTableControlId: string =
	"20d1cd6e-4de7-4fcb-ac32-8059fdfcfbbd";
export const thoughtProcessControlId: string =
	"286b27b9-1b04-42c3-b885-61f01d114b0f";
export const thoughtProcessTableControlId: string =
	"bef044c6-bc22-4875-8ac0-abf722981534";
export const copyFunctionalityTableControlId: string =
	"10125876-2e3a-4471-b1de-b1a30f9fd7f4";
